import React, { useCallback, useState } from "react";
import ReactModal from "react-modal";
import { useSelector, useDispatch } from "react-redux";

import { lookupOperations } from "app/modules/branches/lookup";
import { filterOperations } from "app/modules/branches/filter";

import Branch from "app/components/navigator/branch";

import "./Navigator.scss";

const Navigator = ({ onBranchClick }) => {
  ReactModal.setAppElement("#root");
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const { lookupData, lookupSucceeded, filterSucceeded } = useSelector(
    (state) => state.branchesData
  );

  let branchResults = [];

  if (lookupData) {
    const { locations: branches } = lookupData;
    if (branches) {
      if (branches.result && branches.result.length > 0) {
        branchResults = branches.result.map((branchId) => {
          const branch = branches.data[branchId];
          const schedules = branch.schedules.map((schedule) => (
            <span>{schedule}</span>
          ));
          return (
            <div
              key={branchId}
              className="branches-item"
              onClick={() => onBranchClick(branch)}
            >
              <Branch
                address={branch.address}
                name={branch.name}
                schedules={schedules}
                distance={(branch.distance / 1000).toFixed(2)}
                description={branch.description}
              />
            </div>
          );
        });
      } else {
        if (modal === false && (lookupSucceeded || filterSucceeded)) {
          setModal(true);
        }
      }
    }
  }

  const onCloseModal = useCallback(() => {
    if (modal) {
      setModal(false);
      if (lookupSucceeded) {
        dispatch(lookupOperations.lookupReset());
      }
      if (filterSucceeded) {
        dispatch(filterOperations.filterReset());
      }
    }
  }, [dispatch, modal, filterSucceeded, lookupSucceeded]);

  return (
    <div
      style={{ display: branchResults.length > 0 ? "block" : "none" }}
      className="navigator"
    >
      <div className="navigator__branches">{branchResults}</div>
      {/* <img alt="digipadala-info" src={infographic} /> */}

      <ReactModal
        className="navigator__modal"
        overlayClassName="navigator__modal--overlay"
        isOpen={modal}
        onRequestClose={onCloseModal}
      >
        <span
          className="fa fa-times-circle fa-lg modal-close"
          onClick={onCloseModal}
        ></span>
        <h3>No nearby branches.</h3>
        <hr />
        <span>
          <span role="img" aria-label="warning">
            ⚠️
          </span>{" "}
          Sorry! No branches were found near your area.
          <br />
          <br />
          <span role="img" aria-label="pin">
            📍
          </span>{" "}
          Please try widening your search distance or use another address.
        </span>
      </ReactModal>
    </div>
  );
};

export default Navigator;
